var _circle, _circle2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 36,
    fill: "#5754E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.316 42.5675C58.772 43.207 59 43.5268 59 44C59 44.4732 58.772 44.793 58.316 45.4325C56.2669 48.3059 51.0338 54.5 44 54.5C36.9662 54.5 31.7331 48.3059 29.6841 45.4325C29.228 44.793 29 44.4732 29 44C29 43.5268 29.228 43.207 29.6841 42.5675C31.7331 39.6942 36.9662 33.5 44 33.5C51.0338 33.5 56.2669 39.6942 58.316 42.5675Z",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 44C48.5 41.5146 46.4854 39.5 44 39.5C41.5146 39.5 39.5 41.5146 39.5 44C39.5 46.4854 41.5146 48.5 44 48.5C46.4854 48.5 48.5 46.4854 48.5 44Z",
    stroke: "white",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/iconEye.c8181130f0b1ad9794f8ee04ce4158cf.svg";
export { ForwardRef as ReactComponent };